import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export function useFeatureToggleModal<T>(translationKeyPrefix: string) {
    const [open, setOpen] = useState(false);
    const [row, setRow] = useState<T | null>(null);
    const [enable, setEnable] = useState(false);
    const { t } = useTranslation();

    const openModal = useCallback((payload: T, enableValue: boolean) => {
        setRow(payload);
        setEnable(enableValue);
        setOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setOpen(false);
        setRow(null);
    }, []);

    const modalProps = useMemo(
        () => ({
            open,
            onClose: closeModal,
            title: t(
                enable
                    ? `${translationKeyPrefix}.activate_title`
                    : `${translationKeyPrefix}.deactivate_title`,
            ),
            description: t(
                enable
                    ? `${translationKeyPrefix}.activate_description`
                    : `${translationKeyPrefix}.deactivate_description`,
            ),
            confirmLabel: t(
                enable
                    ? `${translationKeyPrefix}.confirm_activate`
                    : `${translationKeyPrefix}.confirm_deactivate`,
            ),
            confirmButtonColor: (enable ? "success" : "error") as "success" | "error",
        }),
        [t, enable, translationKeyPrefix, open, closeModal],
    );

    return { row, enable, openModal, closeModal, modalProps };
}
